<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Tipo de campo')"
                      :formItemConfig="fiOptions"
                      :decorator="['field_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :params="dynamic_load_field_type">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
            <a-input
              class="ant-lowercase"
              v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'},
              { type: 'string', validator: validateField }
              ]}]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Valor')">
            <a-input
              class="ant-lowercase"
              v-decorator="['valor', { rules: [{ required: false }]}]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Requerido')" :has-feedback="false">
            <a-checkbox v-decorator="['required', {rules: [{ required: true, message: 'Valor requerido'}],
             valuePropName: 'checked', initialValue: false}]">
            </a-checkbox>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Activo')" :has-feedback="false">
            <a-checkbox v-decorator="['active', {valuePropName: 'checked'}]">
            </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-alert
          message="Información"
          type="info"
          show-icon
        >
          <template slot="description">
            El campo <strong>"Nombre"</strong> debe estar en minúscula. Este campo corresponde a
            los encabezados del archivo de <strong>(Excel)</strong>.
          </template>
        </a-alert>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['dynamic_load_id'],
    data () {
      return {
        dynamic_load_field_type: {h_lookup_type: 'DYNAMIC_LOAD_FIELD_TYPE', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'dynamic_load_field',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Tipo de campo', dataIndex: 'field_type', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Valor', dataIndex: 'valor', sorter: true},
              {title: 'Requerido', dataIndex: 'required_desc', sorter: true},
              {title: 'Activo', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'field_type'},
            {name: 'name'},
            {name: 'valor'},
            {name: 'required'},
            {name: 'active', type: 'boolean'}
          ]
        }
      }
    },
    methods: {
      validateField (rule, value, callbackfn) {
        /* deebe terer una minus */
        let contieneMinus = (/[a-z]/.test(value)) && value === value.toLowerCase()
        if (!contieneMinus) {
          callbackfn('En nombre debe de ser en minúsculas')
        }
        callbackfn()
      }
    },
    computed: {
      parentData () {
        return {
          dynamic_load_id: this.dynamic_load_id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GDynamicLoads/DynamicLoadFields.vue